// Pathの正解/不正解/SKIPの合計数が0
export const PATH_STATE_NOT_YET_STARTED = 0;
// Pathの正解/不正解/SKIPの合計数が1以上
export const PATH_STATE_IN_PROGRESS = 1;
// PathのSKIP合計数が0
export const PATH_STATE_COMPLETED = 2;

// Pathstep中、1つも正解がない
export const PATHSTEP_STATE_NOT_YET_STARTED = 0;
// Pathstep中、1つ以上正解
export const PATHSTEP_STATE_IN_PROGRESS = 1;
// Pathstep全問正解
export const PATHSTEP_STATE_COMPLETED = 2;

// act正解
export const ACT_STATE_OK = 0;
// act不正解
export const ACT_STATE_NG = 1;
// actスキップ
export const ACT_STATE_SKIP = 2;

/**
 * lessonの状態
 */
export const LESSON_STATE_INIT = "init";
export const LESSON_STATE_PREPARE = "prepare";
export const LESSON_STATE_START = "start";
export const LESSON_STATE_PAUSE = "pause";
export const LESSON_STATE_RESTART = "restart";
export const LESSON_STATE_STOP = "stop";
export const LESSON_STATE_END = "end";

/**
 * Pathタイプ
 */
export const PATH_TYPE_GENERAL = "general";
export const PATH_TYPE_LISTENING = "listening";
export const PATH_TYPE_SPEAKING = "speaking";
export const PATH_TYPE_PRONUNCIATION = "pronunciation";
export const PATH_TYPE_READING = "reading";
export const PATH_TYPE_EARLY_READING = "early_reading";
export const PATH_TYPE_WRITING = "writing";
export const PATH_TYPE_GRAMMAR = "grammar";
export const PATH_TYPE_PARROT_MILESTONE = "parrot_milestone";
export const PATH_TYPE_PRODUCTION_MILESTONE = "production_milestone";
export const PATH_TYPE_REVIEW = "review";
export const PATH_TYPE_LAGGED_REVIEW = "lagged_review";
export const PATH_TYPE_VOCABULARY = "vocabulary";
export const PATH_TYPE_LISTENING_AND_READING = "listening_and_reading";
export const PATH_TYPE_ESCHOOL = "eschool";

/**
 * 設定画面の文字サイズ
 */
export const TEXT_SIZE_SETTING_LARGE = "large";
export const TEXT_SIZE_SETTING_MIDDLE = "middle";
export const TEXT_SIZE_SETTING_SMALL = "small";
export const TEXT_SIZE_SETTING_LIST = [
  TEXT_SIZE_SETTING_LARGE,
  TEXT_SIZE_SETTING_MIDDLE,
  TEXT_SIZE_SETTING_SMALL
]



// WEBPACK FOOTER //
// ./src/store/constants.js